// Shared narration text for the Guided Tour (used by the card and the voiceover).
export function topStrength(inst) {
  return [
    ["Financial Resources", inst.financial],
    ["Impact and Innovation", inst.impact],
    ["Prestige and Value", inst.prestige],
    ["Sustainability", inst.sustainability],
    ["Brand Awareness", inst.brand],
  ]
    .filter(([, v]) => v != null)
    .sort((a, b) => b[1] - a[1])[0];
}

export function narrationText(inst) {
  const top = topStrength(inst);
  return `${inst.name}. Ranked number ${inst.rank}, with a composite resiliency of ${inst.resiliency_rating.toFixed(
    1
  )}. Its standout strength is ${top[0]}, at ${top[1].toFixed(0)}.`;
}
